import React, { useCallback } from 'react'
import { ThemeProvider } from 'styled-components'
import useSound from 'use-sound'

import { KEY_VALUES } from '../../constants'
import { THEME } from '../../styles'
import { useTranslation } from '../../contexts/I18nContext'
import { useTheme } from '../../contexts/ThemeContext'

import Styled from './ThemeSwitcher.styled'

const ThemeSwitcher = ({ className, variant }) => {
  const { theme, setTheme } = useTheme()
  const { t } = useTranslation()

  const [playOn] = useSound('/assets/sounds/switch-on.mp3', {
    id: 'theme-switcher-switch-on',
  })
  const [playOff] = useSound('/assets/sounds/switch-off.mp3', {
    id: 'theme-switcher-switch-off',
  })

  const handleChange = useCallback(
    (event) => {
      event.preventDefault()
      const newTheme = theme === 'light' ? 'dark' : 'light'
      if (newTheme) {
        setTheme(newTheme)
        if (newTheme === 'light') {
          playOn()
        } else if (newTheme === 'dark') {
          playOff()
        }
      }
    },
    [playOff, playOn, setTheme, theme],
  )

  return theme ? (
    <ThemeProvider theme={{ variant }}>
      <Styled className={className}>
        <Styled.container
          role="button"
          tabIndex={0}
          onClick={handleChange}
          onKeyPress={(event) => {
            if (event.key === KEY_VALUES.ENTER) {
              handleChange(event)
            }
          }}
        >
          <Styled.iconTheme
            isDark={theme === 'dark'}
            size={16}
            backgroundColor={
              variant === 'page'
                ? THEME.COLORS.default.white
                : THEME.COLORS.background.primary
            }
          />
          <Styled.label>{t(`THEMES.${theme.toUpperCase()}`)}</Styled.label>
        </Styled.container>
      </Styled>
    </ThemeProvider>
  ) : null
}

ThemeSwitcher.defaultProps = {
  variant: 'footer',
}

export default ThemeSwitcher
